export const API_URL = 'https://qlitex.com:3001/api/';
export const pageSizes = [5, 10, 20, 50, 100];
export const awsCdnPrefix = "https://d1u6ldzfrr5re5.cloudfront.net/";
export const userPicturePrefix = "user_profile_images/";
export const customerPicturePrefix = "customer_images/";
export const userDefaultPicture = "https://d1u6ldzfrr5re5.cloudfront.net/user_profile_images/profile_image_default.avif";
export const customerDefaultPicture = "https://d1u6ldzfrr5re5.cloudfront.net/customer_images/customer_default_image.png";
export const MAPS_API_KEY = 'AIzaSyAklaBs8byT3HG5Rp7fLCj32CL7uxeP6UY';
export const GEOCODING_API_KEY = 'AIzaSyAklaBs8byT3HG5Rp7fLCj32CL7uxeP6UY';
export const learnerTeacherIntroVideo = "https://d1u6ldzfrr5re5.cloudfront.net/other_videos/intro-video.mp4";